import RequestCache from "./RequestCache";

export default class TeethDefects extends RequestCache {
    get cacheInterval() {
        return 7;
    }

    get link() {
        return this.links.teethDefects;
    }
}
